import type { IconData } from '@stacksjs/iconify-core'

export const tube: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 7a1 1 0 1 1 0 2v2a1 1 0 0 1 0 2v4a1 1 0 0 0 2 0V2H2zM0 0h6v17a3 3 0 0 1-6 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default tube
